module.exports = "https://static.wanderu.com/static/media/surprised-chiku.552ab42b.svg";